import { useTranslation } from 'react-i18next'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { formatDate } from '@/utils/date'
import type { IDeletedHistoryItem } from '@/store/api/Enterprise/Enterprise.types'
import useMobileMediaQuery from '@/hooks/useMobileMediaQuery'
import useTabletMediaQuery from '@/hooks/useTabletMediaQuery'
import useSmallMobileMediaQuery from '@/hooks/useSmallMobileMediaQuery'
import { textEllipsis } from '@/utils/strings'

export const DeletedSocialAnalysisItem = (data: IDeletedHistoryItem) => {
  const { t } = useTranslation()
  const isMobile = useMobileMediaQuery()
  const isSmallMobile = useSmallMobileMediaQuery()
  const isTablet = useTabletMediaQuery()
  const isMobileDevice = isTablet || isSmallMobile || isMobile

  const initials = data.subjectFullName
    ? data.subjectFullName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : ''

  return (
    <div className="bg-neutralColor5 rounded-2xl flex flex-row items-center p-3 h-auto min-h-[65px] w-full gap-4">
      <div
        className={`flex items-center gap-3 ${
          isMobileDevice ? 'w-full justify-between' : 'w-1/3'
        }`}
      >
        <div className="flex items-center gap-3">
          <Avatar>
            <AvatarImage />
            <AvatarFallback className="bg-baseColorHighlight text-neutralColor">
              {initials}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col overflow-hidden">
            <p className="text-neutralColor text-base font-medium truncate">
              {textEllipsis(data.subjectFullName || '', isMobile ? 20 : 50)}
            </p>
            <p className="text-neutralColor60 text-xs font-medium">
              {t('dashboard.reports.deleted.reason')}: {data.deletionReason}
            </p>
          </div>
        </div>
      </div>

      {!isMobileDevice && (
        <>
          <div className="flex flex-col w-1/4 gap-1">
            <p className="text-neutralColor text-xs font-medium">
              {t('dashboard.reports.deleted.originalDate')}
            </p>
            <p className="text-neutralColor60 text-xs font-medium">
              {formatDate(data.originalCompletedAt, 'MM/dd/yyyy')}
            </p>
          </div>

          <div className="flex flex-col w-1/4 gap-1">
            <p className="text-neutralColor text-xs font-medium">
              {t('dashboard.reports.deleted.deletionDate')}
            </p>
            <p className="text-neutralColor60 text-xs font-medium">
              {formatDate(data.deletedAt, 'MM/dd/yyyy')}
            </p>
          </div>
        </>
      )}
    </div>
  )
}
